module.exports = __webpack_public_path__ + "img/semimagem.935c75af.png";